import { UserRoleDTO } from "../DTO/userRoleDTO";

export class UserRole {
    
    public id! : number;
    public name! : string;

    public static mapFromDTO(param:UserRoleDTO):UserRole{ 
        if (!param) throw new Error("parameter is null")
        let obj = new UserRole();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:UserRole):UserRoleDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new UserRoleDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

}